import { render, staticRenderFns } from "./COAForm.vue?vue&type=template&id=6f4ec7b8"
import script from "./COAForm.vue?vue&type=script&lang=js"
export * from "./COAForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports